var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"name":"Conjunc"}},[_c('div',{staticClass:"wrapper-nav-sp"},[_c('div',{class:_vm.navClass,style:(("height:" + _vm.navH + "px"))})])])}
var staticRenderFns = []

export { render, staticRenderFns }